import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n' 
import router from './router' 


Vue.config.productionTip = false

Vue.use(VueI18n) // 2. Vue 使用 VueI18n 插件
Vue.config.productionTip = false


// 3. 加载本地化文件的函数
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// 4. 决定初始语言
let userLanguage = localStorage.getItem('userLanguage');
if (!userLanguage) {
  const browserLang = navigator.language || navigator.userLanguage;
  userLanguage = browserLang.toLowerCase().startsWith('en') ? 'en' : 'zh'; // 确保比较时使用小写
} else if (userLanguage !== 'en' && userLanguage !== 'zh') {
  userLanguage = 'zh'; // 如果存储的语言无效，则回退到'zh'
}

// 5. 创建 VueI18n 实例
const i18n = new VueI18n({
  locale: userLanguage,         // 设置初始区域设置
  fallbackLocale: 'en',       // 设置回退区域设置
  messages: loadLocaleMessages(), // 设置区域设置信息
  silentTranslationWarn: true, // 可以选择性地关闭一些翻译警告，但最好在开发中开启
})

// 6. 将 i18n 实例传递给 Vue 根实例
new Vue({
  router,
  i18n, // 把 i18n 注入到 Vue 实例中
  render: h => h(App),
}).$mount('#app')